import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { API } from '../../constants';
import { RadioButton } from '../radioButton';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import moment from 'moment';
import { Spinner } from "reactstrap";
import { numberWithCommas, numberWithCommasColumns, roundTO, getCompanyData, defaultComponentOptions } from '../utilities';
import { useWindowSize } from '../useWindowSize';


function BrutoBilansSintetike() {
    const windowSize = useWindowSize();
    const [finBrutoBilans1, setFinBrutoBilans1] = useState(null);
    const [konto, setKonto] = useState(null);
    const [kontoDo, setKontoDo] = useState(null);
    const [selectDataKonto, setSelectDataKonto] = useState([]);
    const [sumduguje, setSumDuguje] = useState(0);
    const [sumpotraz, setSumPotraz] = useState(0);
    const [sum, setSum] = useState(0);
    const [sumPocDuguje, setSumPocDuguje] = useState(0);
    const [sumPocPotraz, setSumPocPotraz] = useState(0);
    const [sumPromDuguje, setSumPromDuguje] = useState(0);
    const [sumPromPotraz, setSumPromPotraz] = useState(0);
    const [zakSum, setZakSum] = useState(0);
    const [spinner, setSpinner] = useState(false);
    const [modalErrorOpenPrint, setModalErrorOpenPrint] = useState(false);
    const [pending, setPending] = React.useState(false);

    // stejtovi za spinere na dugmadima
    const [faSpinBB, setFaSpinBB] = useState(false);
    const [faSpinZL, setFaSpinZL] = useState(false);
    const [itemDisable, setItemDisable] = useState(false);

    const [errorDateFrom, setErrorDateFrom] = useState(false);
    const [errorDateTo, setErrorDateTo] = useState(false);
    const [errorMsgDateFrom, setErrorMsgDateFrom] = useState(false);
    const [errorMsgDateTo, setErrorMsgDateTo] = useState(false);

    const kontoOdRef = useRef();
    const kontoDoRef = useRef();
    const datumOdRef = useRef();
    const datumDoRef = useRef();

    const [date, setDate] = useState({
        checkDatDok: true,
        checkDatNalog: false
    });

    const [form, setForm] = useState({
        KONTOOD: '',
        KONTODO: '',
        DATUMOD: '',
        DATUMDO: '',
        PROVJERA: '',
        buttonType: '',
    })

    // funkcija za povlacenje podataka o preduzecu
    getCompanyData(form)

    // funkcija za popunjavanje datumskih polja u zavisnosti od godine
    const checkCompanyYear = () => {
        //  let dateFrom
        //  let dateTo
        let currentDate = new Date()
        if (currentDate.getFullYear() === Number(form.companyYear)) {
            setForm(prev => ({ ...prev, DATUMOD: moment.unix(new Date(currentDate.getFullYear(), 0, 1).getTime() / 1000).format("DD.MM.YYYY"), DATUMDO: moment.unix(new Date().getTime() / 1000).format("DD.MM.YYYY") }))
        } else {
            let oldYear = new Date()
            oldYear = new Date(Number(oldYear.setFullYear(form.companyYear)))
            setForm(prev => ({ ...prev, DATUMOD: moment.unix(new Date(oldYear.getFullYear(), 0, 1).getTime() / 1000).format("DD.MM.YYYY"), DATUMDO: moment.unix(new Date(Number(oldYear.setFullYear(form.companyYear))).getTime() / 1000).format("DD.MM.YYYY") }))
        }
    }

    const getReports = () => {
      //  console.log(form, 'form')
        if (form) {
            form.checkDatDok = date.checkDatDok;
            form.KONTOOD = konto && konto.KONTO ? konto.KONTO : form.KONTOOD;
            form.KONTODO = kontoDo && kontoDo.KONTO ? kontoDo.KONTO : form.KONTODO;
        }

        fetch(API + `/brutoBilansSintetikeMreza/all/${form.companyCode}`, {
            method: 'POST',
            body: JSON.stringify(form),
            headers: {
                'Authorization': `Bearer ${form.token}`,
                'Content-type': 'application/json; charset=UTF-8'
            },
        })
            .then((response) => response.json())
            .then(data => {
                setFinBrutoBilans1(data.items)
                let DUGUJESum = 0;
                let POTRAZSum = 0;
                let SALDOSum = 0;
                let POCDUGUJESum = 0;
                let POCPOTRAZSum = 0;
                let PROMDUGUJESum = 0;
                let PROMPOTRAZSum = 0;
                let ZAKSALDOSum = 0;
                // petlja za citanje podataka
                for (let i = 0; i < data.items.length; i++) {
                    if (form.buttonType.startsWith('bruto')) {
                        DUGUJESum += data.items[i].DUGUJE
                        POTRAZSum += data.items[i].POTRAZ
                        SALDOSum += (data.items[i].DUGUJE) - (data.items[i].POTRAZ)
                    }
                    POCDUGUJESum += data.items[i].POCETNO_DUGUJE
                    POCPOTRAZSum += data.items[i].POCETNO_POTRAZ
                    PROMDUGUJESum += data.items[i].PROMET_DUGUJE
                    PROMPOTRAZSum += data.items[i].PROMET_POTRAZ
                    ZAKSALDOSum += ((data.items[i].POCETNO_DUGUJE) + (data.items[i].PROMET_DUGUJE)) - ((data.items[i].POCETNO_POTRAZ) + (data.items[i].PROMET_POTRAZ))
                }

                if (form.buttonType.startsWith('bruto')) {
                    setSumDuguje(numberWithCommasColumns(roundTO(DUGUJESum, 2)))
                    setSumPotraz(numberWithCommasColumns(roundTO(POTRAZSum, 2)))
                    setSum(numberWithCommasColumns(roundTO(SALDOSum, 2)))
                    setPending(false)
                }
                setSumPocDuguje(numberWithCommasColumns(roundTO(POCDUGUJESum, 2)))
                setSumPocPotraz(numberWithCommasColumns(roundTO(POCPOTRAZSum, 2)))
                setSumPromDuguje(numberWithCommasColumns(roundTO(PROMDUGUJESum, 2)))
                setSumPromPotraz(numberWithCommasColumns(roundTO(PROMPOTRAZSum, 2)))
                setZakSum(numberWithCommasColumns(roundTO(ZAKSALDOSum, 2)))
                setPending(false)
            })
    }

    const print = () => {
        setSpinner(true)
        // uslov: ako nije izabran datum od datum do i ako nije izabran izvjestaj(nije kliknuto na dugme za izvjestaj), nece otvoriti izvjestaj 
        if (!unosIspravanDo('PRINT')) return setSpinner(false)
        if (form.buttonType === "") return setSpinner(false), setModalErrorOpenPrint(true)
        if (form) {
            form.NAZIV_PRED = form.companyName;
            form.checkDatDok = date.checkDatDok;
            form.KONTOOD = konto && konto.KONTO ? konto.KONTO : form.KONTOOD;
            form.KONTODO = kontoDo && kontoDo.KONTO ? kontoDo.KONTO : form.KONTODO;
        }

        // fetch za crtanje izvjestaja
        // u bodiju saljemo sql koji je vec pokupio i form
        fetch(API + `/` + form.buttonType + `/print/${form.companyCode}`, {
            method: 'POST',
            body: JSON.stringify({ form }),
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${form.token}`,
                'Content-type': 'application/json; charset=UTF-8'
            },
        })
            .then((response) => response.json())
            .then(data => {
                window.open(API + data.link)
                setSpinner(false)
            })
    }

    // funkcija koja poziva citanje konta
    const getKontoData = () => {
        fetch(API + `/konto/all`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${form.token}`,
                'Content-type': 'application/json; charset=UTF-8'
            },
        })
            .then((response) => response.json())
            .then(data => {
                setSelectDataKonto(data)
            })
    }

    useEffect(() => {
        getKontoData()
    }, [])


    // cekiranje radio dugmadi u zavisnosti odabrane opcije
    const radioChangeHandler = (e) => {
        if (e.target.name === 'checkDatDok') {
            setDate({
                // odabir datuma dokumenata
                checkDatDok: true,
                checkDatNalog: false
            });
        } else {
            setDate({
                checkDatDok: false,
                // odabir datuma storniranja
                checkDatNalog: true
            });
        }
    };

    // funkcija za kontrolu obaveznih polja
    function unosIspravanDo(name) {

        if (name === 'KONTOOD') {
            return true
        }

        if (name === 'KONTODO') {
            return true
        }

        if (name === 'DATUMOD') {
            return true
        }

        let reqex = /^(0[1-9]|[12]\d|3[01]).(0[1-9]|1[0-2]).([12]\d{3})$/gi;

        if (!reqex.test(form.DATUMOD)) {
            setErrorDateFrom(true)
            setErrorMsgDateFrom('Datum od nije validan!')
            datumOdRef.current.focus();
            return false
        } else {
            setErrorDateFrom(false)
            setErrorMsgDateFrom(null)
        }

        if (name === 'DATUMDO') {
            return true
        }

        let reqexDATUMDO = /^(0[1-9]|[12]\d|3[01]).(0[1-9]|1[0-2]).([12]\d{3})$/gi;

        if (!reqexDATUMDO.test(form.DATUMDO)) {
            setErrorDateTo(true)
            setErrorMsgDateTo('Datum do nije validan!')
            datumDoRef.current.focus();
            return false
        } else {
            setErrorDateTo(false)
            setErrorMsgDateTo(null)
        }

        if (name === 'PROVJERA') {
            return true
        }

        return true
    }

    let sirinaZaKoloneVrijednosti = windowSize.width > 1920 ? '220px'
        : windowSize.width > 1680 ? '120px'
            : windowSize.width > 1600 ? '110px'
                : windowSize.width > 1440 ? '120px'
                    : windowSize.width > 1280 ? '120px'
                        : windowSize.width > 1024 ? '100px'
                            : '80px';

    let sirinaZaKoloneVrijednostiZakljucniList = windowSize.width > 1920 ? '150px'
        : windowSize.width > 1680 ? '120px'
            : windowSize.width > 1600 ? '120px'
                : windowSize.width > 1440 ? '120px'
                    : windowSize.width > 1280 ? '120px'
                        : windowSize.width > 1024 ? '100px'
                            : '80px';

    // funkcija za popunjavanje kolona u mrezi
    function checkingFields() {
        let rbr =
        {
            name: 'Rbr',
            selector: row => row.RBR,
            // sirina polja po rezolucijama
            width:
            windowSize.width > 2048 ? '150px'
               : windowSize.width > 1920 ? '100px'
                    : windowSize.width > 1680 ? '100px'
                        : windowSize.width > 1600 ? '100px'
                            : windowSize.width > 1440 ? '100px'
                                : windowSize.width > 1280 ? '80px'
                                    : windowSize.width > 1024 ? '80px'
                                        : '80px',
            right: 'boolean',
            cell: (row) => (
                <>
                    <span id='media-query-rows'>{row.RBR}</span>
                </>
            ),
        }
        let konto =
        {
            name: 'Konto',
            selector: row => row.KONTO,
            // sirina polja po rezolucijama
            width:
                windowSize.width > 1920 ? '100px'
                    : windowSize.width > 1680 ? '100px'
                        : windowSize.width > 1600 ? '100px'
                            : windowSize.width > 1440 ? '100px'
                                : windowSize.width > 1280 ? '90px'
                                    : windowSize.width > 1024 ? '90px'
                                        : '90px',
            cell: (row) => (
                <>
                    <span id='media-query-rows'>{row.KONTO}</span>
                </>
            ),
        }
        let kontoNaziv =
        {
            name: 'Naziv',
            selector: row => row.NAZIV,
            // sirina polja po rezolucijama
            width:
            windowSize.width > 2048 ? '1190px'
               : windowSize.width > 1920 ? '820px'
                    : windowSize.width > 1680 ? '700px'
                        : windowSize.width > 1600 ? '600px'
                            : windowSize.width > 1440 ? '530px'
                                : windowSize.width > 1280 ? '410px'
                                    : windowSize.width > 1024 ? '430px'
                                        : '175px',
            cell: (row) => (
                <>
                    <span id='media-query-rows-text'>{row.NAZIV}</span>
                </>
            ),
        }
        let saldo =
        {
            name: 'Saldo',
            selector: row => row.SALDO,
            // sirina polja po rezolucijama
            width: sirinaZaKoloneVrijednostiZakljucniList,
            right: 'boolean',
            cell: (row) => (
                <>
                    <span id='media-query-rows'>{numberWithCommasColumns(row.SALDO)}</span>
                </>
            ),
        }
        if (form.buttonType.startsWith('bruto')) {
            let kontoNaziv =
            {
                name: 'Naziv',
                selector: row => row.NAZIV,
                // sirina polja po rezolucijama
                width:
                windowSize.width > 2048 ? '1280px'
                   : windowSize.width > 1920 ? '900px'
                        : windowSize.width > 1680 ? '930px'
                            : windowSize.width > 1600 ? '870px'
                                : windowSize.width > 1440 ? '770px'
                                    : windowSize.width > 1280 ? '650px'
                                        : windowSize.width > 1024 ? '630px'
                                            : '175px',
                cell: (row) => (
                    <>
                        <span id='media-query-rows-text'>{row.NAZIV}</span>
                    </>
                ),
            }
            let duguje =
            {
                name: 'Duguje',
                selector: row => row.DUGUJE,
                // sirina polja po rezolucijama
                width: sirinaZaKoloneVrijednosti,
                right: 'boolean',
                cell: (row) => (
                    <>
                        <span id='media-query-rows'>{numberWithCommasColumns(row.DUGUJE)}</span>
                    </>
                ),
            }
            let potraz =
            {
                name: 'Potražuje',
                selector: row => row.POTRAZ,
                // sirina polja po rezolucijama
                width: sirinaZaKoloneVrijednosti,
                right: 'boolean',
                cell: (row) => (
                    <>
                        <span id='media-query-rows'>{numberWithCommasColumns(row.POTRAZ)}</span>
                    </>
                ),
            }
            let saldo =
            {
                name: 'Saldo',
                selector: row => row.SALDO,
                // sirina polja po rezolucijama
                width: sirinaZaKoloneVrijednosti,
                right: 'boolean',
                cell: (row) => (
                    <>
                        <span id='media-query-rows'>{numberWithCommasColumns(row.SALDO)}</span>
                    </>
                ),
            }
            return [rbr, konto, kontoNaziv, duguje, potraz, saldo]
        }

        if (form.buttonType.startsWith('zakljucni')) {
            let pocetnoDuguje =
            {
                name: 'Poč. duguje',
                selector: row => row.POCETNO_DUGUJE,
                // sirina polja po rezolucijama
                width: sirinaZaKoloneVrijednostiZakljucniList,
                right: 'boolean',
                cell: (row) => (
                    <>
                        <span id='media-query-rows'>{numberWithCommasColumns(row.POCETNO_DUGUJE)}</span>
                    </>
                ),
            }
            let pocetnoPotraz =
            {
                name: 'Poč. potražuje',
                selector: row => row.POCETNO_POTRAZ,
                // sirina polja po rezolucijama
                width: sirinaZaKoloneVrijednostiZakljucniList,
                right: 'boolean',
                cell: (row) => (
                    <>
                        <span id='media-query-rows'>{numberWithCommasColumns(row.POCETNO_POTRAZ)}</span>
                    </>
                ),
            }
            let prometDuguje =
            {
                name: 'Prom. duguje',
                selector: row => row.PROMET_DUGUJE,
                // sirina polja po rezolucijama
                width: sirinaZaKoloneVrijednostiZakljucniList,
                right: 'boolean',
                cell: (row) => (
                    <>
                        <span id='media-query-rows'>{numberWithCommasColumns(row.PROMET_DUGUJE)}</span>
                    </>
                ),
            }
            let prometPotraz =
            {
                name: 'Prom. potražuje',
                selector: row => row.PROMET_POTRAZ,
                // sirina polja po rezolucijama
                width: sirinaZaKoloneVrijednostiZakljucniList,
                right: 'boolean',
                cell: (row) => (
                    <>
                        <span id='media-query-rows'>{numberWithCommasColumns(row.PROMET_POTRAZ)}</span>
                    </>
                ),
            }
            return [rbr, konto, kontoNaziv, pocetnoDuguje, pocetnoPotraz, prometDuguje, prometPotraz, saldo]
        }
    }

    // funkcija koja se poziva prilikom promjene vrijednosti u inputu
    const handleChange = (event) => {
        const target = event.target;
        let value = target.value;
        const name = event.target.name;
        // postavlja sa funkcijom  setForm((prevState) mijejenja predhodno stanje sa novom vrijednoscu
        setForm((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };


    const defaultPropsKonto = {
        options: selectDataKonto,
        getOptionLabel: (option) => option ? `${option.KONTO} ${option.NAZ}` : '',
    };

    return (

        <div>
            {/* Kontejner za naslov  */}
            <div className="title-container">
                {/* Naziv forma */}
                <header className="title-header">
                    <h1 id="media-query-title">Sintetička kartica</h1>
                </header>

                <div >
                    <div>
                        {/* Klasa za ikonice, stampa*/}
                        <ul >
                            <input type="image" alt="print" className='dugme-stampa' title='Štampa' tabIndex="7" src={require('../../assets/images/printer.png')} onClick={print} disabled={spinner} />
                        </ul>
                    </div>
                </div>
            </div>
            <Container fluid>
                <div className="row">
                    <Col lg='2'>

                        <div className='form-field-container' style={{ display: 'contents' }}>
                            {/* red sirine */}
                            <Col lg='12'>
                                {/* definsanje froma za radio dugmad */}
                                <div className=" flex-lg-row justify-content-end" id='media-query-buttonType'>
                                    <div style={{ display: 'inline-grid' }} className="btn-report">
                                        <RadioButton
                                            changed={(e) => radioChangeHandler(e)}
                                            isSelected={date?.checkDatDok}
                                            label="Dat.dok"
                                            id="1"
                                            value={date?.checkDatDok}
                                            name='checkDatDok'
                                        />
                                    </div>
                                    <div style={{ display: 'inline-grid' }} className="btn-report">
                                        <RadioButton
                                            changed={(e) => radioChangeHandler(e)}
                                            isSelected={date?.checkDatNalog}
                                            label="Dat.nal"
                                            id="2"
                                            value={date?.checkDatNalog}
                                            name='checkDatNalog'
                                        />
                                    </div>
                                </div>
                            </Col>
                        </div>
                    </Col>

                    <Col lg='6'>

                        <div className="col-12" style={{ display: 'flex', }}>
                            <div className="col-12">

                                <div className="form-group row label-box-div">
                                    <label className="col-form-label col-lg-2 label-box" id="media-query-label-report">Konto od:</label>

                                    <div className="col-4">
                                        <Autocomplete
                                            {...defaultPropsKonto}
                                            freeSolo
                                            //   autoSelect
                                            value={konto}
                                            disablePortal={true}
                                            onFocus={() => {
                                                unosIspravanDo("KONTOOD")
                                            }}
                                            onChange={(event, newValue) => {
                                                setForm(prev => ({ ...prev, KONTOOD: newValue && newValue != '' ? newValue.ID : '' }))
                                                setKonto(newValue);
                                                // fokus se mora vratiti inace tabIndex ne radi dobro
                                                kontoOdRef.current.focus()
                                            }}

                                            renderInput={(params) => (
                                                <TextField {...params}
                                                    type="text"
                                                    autoFocus
                                                    tabIndex="1"
                                                    // onInput={(e) => {
                                                    //     e.target.value = (e.target.value).slice(0, 3)
                                                    // }}

                                                    className="clients-textinput"
                                                    ref={kontoOdRef}
                                                    value={form?.KONTOOD}
                                                    placeholder=' Izaberite konto'
                                                    variant="standard"
                                                    name='KONTOOD'
                                                    onChange={(e) => handleChange(e)} />
                                            )}
                                        />
                                    </div>

                                    <label className="col-form-label col-lg-1 label-box" id="media-query-label-DateTo">do:</label>
                                    <div className="col-4">
                                        <Autocomplete
                                            {...defaultPropsKonto}
                                            freeSolo
                                            value={kontoDo}
                                            disablePortal={true}
                                            onFocus={() => {
                                                unosIspravanDo("KONTODO")
                                                  // focus se mora vratiti na polje ako se upisuje vrijednost(ne uzima se se vrijednost iz liste)  
                                                //   const timeout = setTimeout(() => {
                                                //     kontoDoRef.current.focus()
                                                // }, 200);
                                                // return () => {
                                                //     clearTimeout(timeout);
                                                // };
                                            }}
                                            onChange={(event, newValue) => {
                                                setForm(prev => ({ ...prev, KONTODO: newValue && newValue != '' ? newValue.ID : '' }))
                                                setKontoDo(newValue);
                                                // fokus se mora vratiti inace tabIndex ne radi dobro
                                                kontoDoRef.current.focus()
                                            }}

                                            renderInput={(params) => (
                                                <TextField {...params}
                                                    tabIndex="2"
                                                    className="clients-textinput"
                                                    ref={kontoDoRef}
                                                    value={form?.KONTODO}
                                                    placeholder=' Izaberite konto'
                                                    variant="standard"
                                                    name='KONTODO'
                                                    onChange={(e) => {
                                                        handleChange(e)
                                                        // focus se mora vratiti na polje ako se upisuje vrijednost(ne uzima se se vrijednost iz liste)
                                                        const timeout = setTimeout(() => {
                                                            kontoDoRef.current.focus()
                                                        }, 200);
                                                        return () => {
                                                            clearTimeout(timeout);
                                                        };
                                                    }}
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12" style={{ display: 'flex', }}>
                            <div className="col-12">

                                <div className="form-group row label-box-div">
                                    <label className="col-form-label col-lg-2 label-box" id="media-query-label-report">Datum od:</label>
                                    <div className="col-2">
                                        <div className={errorDateFrom ? 'inputWithError' : 'field-container'}>
                                            <input
                                                type='text'
                                                tabIndex="3"
                                                id="media-query-input"
                                                ref={datumOdRef}
                                                onFocus={() => {
                                                    unosIspravanDo("DATUMOD")
                                                    checkCompanyYear();
                                                }}
                                                placeholder="datum od"
                                                name='DATUMOD'
                                                value={form?.DATUMOD}
                                                onChange={(e) => handleChange(e)} />
                                            {errorMsgDateFrom ? <span style={{ width: '100%', color: 'red', fontSize: '11px', fontFamily: 'cursive' }}>{errorMsgDateFrom}</span> : ''}
                                        </div>
                                    </div>

                                    <label className="col-form-label col-lg-3 label-box" id="media-query-label-DateTo">do:</label>
                                    <div className="col-2">
                                        <div className={errorDateTo ? 'inputWithError' : 'field-container'}>
                                            <input type='text'
                                                tabIndex="4"
                                                id="media-query-input-to"
                                                ref={datumDoRef}
                                                onFocus={() => {
                                                    unosIspravanDo("DATUMDO")
                                                }}
                                                placeholder="datum do"
                                                value={form?.DATUMDO}
                                                name='DATUMDO'
                                                onChange={(e) => handleChange(e)} />
                                            {errorMsgDateTo ? <span style={{ width: '100%', color: 'red', fontSize: '11px', fontFamily: 'cursive' }}>{errorMsgDateTo}</span> : ''}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col lg='4'>
                        <Row>
                            <Col lg='12' >
                                <div className=" flex-lg-row justify-content-end" id='media-query-buttonType'>
                                    <div style={{ display: 'inline-grid' }}>
                                        <div className={faSpinBB ? "btn-report-red" : "btn-report"}>
                                            <button tabIndex={5}
                                                onFocus={() => {
                                                    unosIspravanDo("PROVJERA")
                                                }}
                                                onClick={() => {
                                                    // uslov: ako nisu unesena obavezna polja, zaustavlja upis
                                                    if (!unosIspravanDo('DUGME')) return;
                                                    form.buttonType = 'brutoBilansSintetickaKartica'
                                                    setFaSpinBB(true)
                                                    setFaSpinZL(false)
                                                    setPending(true)
                                                    getReports()
                                                }}>{faSpinBB && !finBrutoBilans1 ? <i className="fa fa-spinner fa-spin"></i> : ''}Bruto bilans</button>
                                        </div>
                                    </div>
                                    <div style={{ display: 'inline-grid' }}>
                                        <div className={faSpinZL ? "btn-report-red" : "btn-report"}>
                                            <button tabIndex={6}
                                                onClick={() => {
                                                    // uslov: ako nisu unesena obavezna polja, zaustavlja upis
                                                    if (!unosIspravanDo('DUGME')) return;
                                                    form.buttonType = 'zakljucniList'
                                                    setFaSpinBB(false)
                                                    setFaSpinZL(true)
                                                    setPending(true)
                                                    getReports()
                                                }}>{faSpinZL && !finBrutoBilans1 ? <i className="fa fa-spinner fa-spin"></i> : ''}Zaključni list</button>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>

                </div>
            </Container >

            {
                < DataTable
                    columns={form.buttonType ? checkingFields() : []}
                    data={finBrutoBilans1 ? finBrutoBilans1 : []}
                    pagination
                    responsive
                    striped
                    dense
                    pointerOnHover
                    paginationComponentOptions={defaultComponentOptions}
                    paginationPerPage={[windowSize.height > 1300 ? 32
                        : windowSize.height > 1246 ? 29
                        : windowSize.height > 1222 ? 28
                        : windowSize.height > 1200 ? 27
                        : windowSize.height > 1000 ? 23
                        : windowSize.height > 920 ? 19
                        : windowSize.height > 900 ? 18
                        : windowSize.height > 880 ? 17
                        : windowSize.height > 820 ? 15
                        : windowSize.height > 720 ? 14
                                            : 4]}
                    progressPending={pending}
                />
            }

            <div>
                <Modal isOpen={modalErrorOpenPrint} centered  >
                    <ModalHeader>Upozorenje!</ModalHeader>
                    <ModalBody>
                        <span>{`Izaberite izvještaj koji želite štampati!`}</span>
                    </ModalBody>
                    <ModalFooter>
                        <div>
                            {/* Dugme za zatvaranje modalnog forma */}
                            <button onClick={() => setModalErrorOpenPrint(false)} className="button-yes">Ok</button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
            {form.buttonType.startsWith('zakljucni') ?
                <div className="naslov-ikonice">
                    <ul className="nav flex-column flex-lg-row justify-content-end">
                        <div style={{ display: 'flex', justifyContent: 'end', position: 'fixed', bottom: '0', flex: '0 0 auto' }}>

                            <li className="nav-item toolbaritem" style={{ width: '16%', marginRight: '5px' }}>
                                <div className='col-form-right'>
                                <div className="field-container-number-totals">
                                        <label id="media-query-label-sum">Poč. duguje</label>
                                        <input className="form-control" readOnly={true} tabIndex="-1" type='text' id="media-query-input-text" value={sumPocDuguje && sumPocDuguje != 'NaN' ? sumPocDuguje : 0} />
                                    </div>
                                </div>
                            </li>

                            <li className="nav-item toolbaritem" style={{ width: '16%', marginRight: '4px' }}>
                                <div className='col-form-right'>
                                <div className="field-container-number-totals">
                                        <label id="media-query-label-sum">Poč. potražuje</label>
                                        <input className="form-control" readOnly={true} type='text' tabIndex="-1" id="media-query-input-text" value={sumPocPotraz && sumPocPotraz != 'NaN' ? sumPocPotraz : 0} />
                                    </div>
                                </div>
                            </li>

                            <li className="nav-item toolbaritem" style={{ width: '16%', marginRight: '5px' }}>
                                <div className='col-form-right'>
                                <div className="field-container-number-totals">
                                        <label id="media-query-label-sum">Prom. duguje</label>
                                        <input className="form-control" readOnly={true} tabIndex="-1" type='text' id="media-query-input-text" value={sumPromDuguje && sumPromDuguje != 'NaN' ? sumPromDuguje : 0} />
                                    </div>
                                </div>
                            </li>

                            <li className="nav-item toolbaritem" style={{ width: '16%', marginRight: '4px' }}>
                                <div className='col-form-right'>
                                <div className="field-container-number-totals">
                                        <label id="media-query-label-sum">Prom. potražuje</label>
                                        <input className="form-control" readOnly={true} type='text' tabIndex="-1" id="media-query-input-text" value={sumPromPotraz && sumPromPotraz != 'NaN' ? sumPromPotraz : 0} />
                                    </div>
                                </div>
                            </li>

                            <li className="nav-item toolbaritem" style={{ width: '16%', marginRight: '7px' }}>
                                <div className='col-form-right'>
                                <div className="field-container-number-totals">
                                        <label id="media-query-label-sum">Saldo</label>
                                        <input type='text' className="total" readOnly={true} id="media-query-input-text" tabIndex="-1" value={zakSum && zakSum != 'NaN' ? (zakSum) : 0} />
                                    </div>
                                </div>
                            </li>
                        </div>
                    </ul>
                </div>
                :
                <div className="naslov-ikonice">
                    <ul className="nav flex-column flex-lg-row justify-content-end">
                        <div style={{ display: 'flex', justifyContent: 'end', position: 'fixed', bottom: '0', flex: '0 0 auto' }}>

                            <li className="nav-item toolbaritem" style={{ width: '23%', marginRight: '5px' }}>
                                <div className='col-form-right'>
                                    <div className="field-container-number-totals">
                                        <label id="media-query-label-sum">Duguje</label>
                                        <input className="form-control" readOnly={true} tabIndex="-1" type='text' id="media-query-input-text" value={sumduguje && sumduguje != 'NaN' ? sumduguje : 0} />
                                    </div>
                                </div>
                            </li>

                            <li className="nav-item toolbaritem" style={{ width: '23%', marginRight: '4px' }}>
                                <div className='col-form-right'>
                                    <div className="field-container-number-totals">
                                        <label id="media-query-label-sum">Potražuje</label>
                                        <input className="form-control" readOnly={true} type='text' tabIndex="-1" id="media-query-input-text" value={sumpotraz && sumpotraz != 'NaN' ? sumpotraz : 0} />
                                    </div>
                                </div>
                            </li>

                            <li className="nav-item toolbaritem" style={{ width: '23%', marginRight: '7px' }}>
                                <div className='col-form-right'>
                                    <div className="field-container-number-totals">
                                        <label id="media-query-label-sum">Saldo</label>
                                        <input type='text' className="total" readOnly={true} id="media-query-input-text" tabIndex="-1" value={sum && sum != 'NaN' ? (sum) : 0} />
                                    </div>
                                </div>
                            </li>
                        </div>
                    </ul>
                </div>

            }
            <div>
                {spinner ? <Spinner className='spinner' color="primary" id='loader' /> : ''}
            </div>
        </div >
    );
}

export default BrutoBilansSintetike;


